// extracted by mini-css-extract-plugin
export default {"modalTitle":"styles_modalTitle__5mU7E","widgetTitle":"styles_widgetTitle__dUMC3"};